/**
 * Tracks the absolute distance an element has scrolled relative to when the ScrollTracker was created.
 * Calls the `onScroll` callback with the total distance scrolled whenever the relative distance is updated.
 * The `destroy` method should be called to unregister the ScrollTracker from the element it is watching to avoid memory leaks.
 */
export class ScrollTracker {

  private static InstanceId = 0;

  private initialScrollTop: number;
  private eventNamespace: string;

  constructor(private element: JQuery, private onScroll: (relativeDistanceScrolled: number) => any) {
    this.initialScrollTop = element.scrollTop();
    this.eventNamespace = '.scroll-tracker-' + ScrollTracker.InstanceId++;
    element.on('scroll' + this.eventNamespace, () => this.updateDistanceScrolled());
  }

  public destroy() {
    this.element.off(this.eventNamespace);
  }

  private updateDistanceScrolled() {
    const scrollTop = this.element.scrollTop();
    const distanceScrolled = Math.abs(scrollTop - this.initialScrollTop);
    this.onScroll(distanceScrolled);
  }

}
